<template>
    <transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-if="showNotificationBadge"
            class="fixed top-24 right-5 w-72 bg-white text-black shadow-popover rounded-lg z-popover ring-1 ring-black/20 overflow-hidden"
        >
            <div class="relative">
                <Notification
                    @notificationClicked="hideBadge"
                    :disableContextMenu="true"
                    :notification="notification"
                    :rounded="false"
                    :showTimeStamp="false"
                    :menuOpenId="null"
                    :canShowUnreadDot="false"
                    :disableClickBusEvent="true"
                />
                <button
                    @click="hideBadge"
                    :class="[
                        'absolute top-2 right-2 group hover:shadow-inner hover:bg-accent-light/30 rounded-full bg-primary text-primary-text p-1 hover:bg-primary-hover transition-colors duration-button-hover',
                    ]"
                >
                    <PhX
                        class="size-5 flex-shrink-0 group-hover:scale-90 transition-transform duration-button-hover fill-current"
                    />
                </button>
                <div class="w-full h-1">
                    <div
                        :class="[
                            badgeProgessbarActive ? 'w-0' : 'w-full',
                            {
                                'transition-width ease-linear duration-[4000ms]':
                                    useTransition,
                            },
                            'h-full bg-primary',
                        ]"
                    ></div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Notification from '@/Components/Notifications/Notification.vue'
import { PhX } from '@phosphor-icons/vue'

export default {
    components: {
        Notification,
        PhX,
    },

    props: {
        notification: Object,
    },

    data() {
        return {
            showNotificationBadge: false,
            badgeProgessbarActive: false,
            useTransition: true,
            showNotifictionTimeOut: null,
        }
    },

    mounted() {
        this.showNotificationBadge = true
        this.resetNotificationBadgeProgress()
    },

    watch: {
        notification() {
            this.resetNotificationBadgeProgress()
        },
    },

    methods: {
        resetNotificationBadgeProgress() {
            if (this.showNotifictionTimeOut) {
                this.showNotifictionTimeOut = clearTimeout(
                    this.showNotifictionTimeOut
                )
            }
            this.showNotifictionTimeOut = setTimeout(() => {
                this.hideBadge()
            }, 4000)

            this.useTransition = false
            this.$nextTick(() => {
                this.badgeProgessbarActive = false
                setTimeout(() => {
                    this.useTransition = true
                    this.badgeProgessbarActive = true
                }, 25)
            })
        },

        hideBadge() {
            this.showNotificationBadge = false
            setTimeout(() => {
                this.$emit('close')
            }, 150)
        },
    },
}
</script>
